import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { HiOutlineSearch } from 'react-icons/hi'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Button from '../General/Button'
import Datepicker from '../Inputs/Datepicker'
import InputText from '../Inputs/InputText'
import SelectOfCategories from '../Inputs/SelectOfCategories'

const AdvancedMovementsForm: React.FC<IAdvancedMovementsForm> = ({
  onCloseAdvancedForm,
  onSubmit,
}) => {
  const form = useForm()

  const [windowWidth, setWindowWidth] = useState(0)

  const [isDateSelected, setIsDateSelected] = useState<boolean>(false)

  const movementsType = [
    {
      text: 'Todos',
      value: 'all',
    },
    {
      text: 'Carga',
      value: 'LOAD',
    },
    {
      text: 'Descarga',
      value: 'UNLOAD',
    },
  ]

  useEffect(() => {
    const { innerWidth } = window
    setWindowWidth(innerWidth)
  }, [])

  return (
    <Form
      form={form}
      onSubmit={(values) => onSubmit({ ...values, isDateSelected })}
      classes="gap-x-2 p-2"
    >
      <HiOutlineSearch
        fontSize={25}
        className="text-primaryGray-400 col-span-1"
      />
      <label className="col-span-11 text-left dark:text-white text-darkere lg:ml-3">
        Búsqueda avanzada
      </label>

      <FormItem name="username" classes="xl:col-span-8 col-span-12 row-start-2">
        <InputText small label="Usuario" maxLength={80} />
      </FormItem>

      <FormItem
        defaultValue={movementsType[0]}
        name="movementType"
        classes="xl:col-span-4 col-span-12 lg:row-start-3 xl:row-start-2"
      >
        {/* <InputText small label="Categoría" maxLength={80} /> */}
        <SelectOfCategories options={movementsType} label="Tipo" />
      </FormItem>

      <div
        className="xl:col-span-6 col-span-12"
        onClick={() => setIsDateSelected(true)}
      >
        <FormItem
          name="from"
          classes="xl:col-span-6 col-span-12"
          rules={{
            required: 'Debe especificar la fecha de creación del producto',
          }}
        >
          <Datepicker
            label="Fecha desde"
            calendarPosition={windowWidth + 100 - windowWidth}
          />
        </FormItem>
      </div>

      <div
        className="xl:col-span-6 col-span-12"
        onClick={() => setIsDateSelected(true)}
      >
        <FormItem
          name="to"
          classes="xl:col-span-6 col-span-12"
          rules={{
            required: 'Debe especificar la fecha de creación del producto',
          }}
        >
          <Datepicker
            label="Fecha hasta"
            calendarPosition={windowWidth + 100 - windowWidth}
          />
        </FormItem>
      </div>

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCloseAdvancedForm()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Buscar
        </Button>
      </div>
    </Form>
  )
}

interface IAdvancedMovementsForm {
  onSubmit: Function
  onCloseAdvancedForm: Function
}

export default AdvancedMovementsForm
